import React from 'react';
import styled from 'styled-components';
import * as Icons from '../Icons';
import * as ButtonLink from '../Button/ButtonLink';
export const DownloadWrapper = styled.div `
  display: flex;
  align-items: center;

  .download-button {
    display: flex;
  }

  .download-file-button {
    text-decoration: none;
    display: inline-flex;
    align-items: center;

    &:hover {
      text-decoration: underline;
    }
  }

  .download-arrow {
    display: inline-flex;
    min-height: 18px;
  }

  &.hide-icon {
    .download-arrow {
      display: none;
    }
  }

  &.hide-icon-for-MD-LG {
    .download-arrow {
      display: inline-flex;
    }
    @media ${(props) => props.theme.md} {
      .download-arrow {
        display: none;
      }
    }
  }

  &.show-text-on-mobile {
    .desktop-text {
      display: inline-flex;
    }
  }

  @media ${(props) => props.theme.md} {
    .download-arrow {
      margin-right: 4px;
    }
  }
`;
export const DesktopText = styled.p `
  margin: 0;
  display: none;

  @media ${(props) => props.theme.md} {
    display: inline-flex;
  }
`;
const DownloadButton = ({ url, text, className, external, type, size, }) => {
    const Button = type ? ButtonLink[type] : ButtonLink.Tertiary;
    return (React.createElement(DownloadWrapper, { className: `${className}` },
        React.createElement(Button, { className: "download-file-button", size: size, external: external, url: url, buttonProps: {
                download: true,
                'data-testid': 'download-button',
                className: 'download-button',
            } },
            React.createElement(Icons.DownloadArrow, { className: "icon" }),
            React.createElement(DesktopText, { className: "desktop-text" }, text))));
};
DownloadButton.defaultProps = {
    size: 'Medium',
    className: '',
    external: true,
};
export default DownloadButton;
